import type {
    ComposableOptionsBase
} from '~/types';
import type { RouteLocationRaw } from 'vue-router';
import { isString as lo_isString } from 'es-toolkit';

export interface UseRouteUtilsOptions extends ComposableOptionsBase {}
export function useRouteUtils(options: Partial<UseRouteUtilsOptions> = {}) {
    
    function canRedirect(
        blacklist: Set<string>,
        route: string | Partial<RouteLocationRaw>
    ): boolean {
        const path = lo_isString(route) ? route : route.path;

        if (path) {
            return !Array.from(blacklist).find((r) => path.startsWith(r));
        }

        return true;
    }

    return {
        canRedirect
    };
}
